<script lang="ts">
  // components
  import UIRouterLink from "@shared/svelte/Components/UIRouterLink.svelte";
  import Icon from "@shared/svelte/Components/Icon.svelte";
  import ProviPayCard from "@retailer/svelte/Payments/ProviPayCard.svelte";

  // props
  export let heading: string = "Invoices";
  export let backLink: string = null;
  export let backLinkParams: { [key: string]: any } = {};

</script>

<div class="fizz-surface">
  <section class="background-white fizz-inset-vertical-16 fizz-inset-horizontal-32 fizz-container">
    <div class="fizz-flex-item fizz-space-between-responsive">
      <ProviPayCard extraClassNames={"fizz-hide-on-large"} />
      <div class="fizz-flex-row">
        {#if backLink}
          <UIRouterLink stateName={backLink} params={backLinkParams}>
            <Icon extraClassNames="fizz-text-brand" type="ArrowLeft" height="12" width="12" />
          </UIRouterLink>
        {/if}
        <h4 class="fizz-heading-4" data-testid="invoice-breadcrumb">{heading}</h4>
      </div>
      <ProviPayCard extraClassNames={"fizz-hide-on-small"} />
    </div>
  </section>
</div>
